import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './store/store';
import { BrowserRouter } from 'react-router-dom';
import { Flip, ToastContainer } from 'react-toastify';
import 'react-tooltip/dist/react-tooltip.css';
import './i18n';

// // Function to clear localStorage and cookies
// function clearStorageAndCookies() {
//   localStorage.clear();
//   document.cookie.split(';').forEach(function (cookie) {
//     let cookieName = cookie.split('=')[0];
//     document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
//   });
// }

// function manageStorage() {
//   const lastClearTime = localStorage.getItem('lastClearTime');
//   const currentTime = Date.now();

//   if (!lastClearTime || currentTime - lastClearTime > 86400000) {
//     clearStorageAndCookies(); // Clear storage and cookies
//     localStorage.setItem('lastClearTime', currentTime); // Update timestamp
//   }
// }

// manageStorage();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <App />
        <ToastContainer
          theme="light"
          position="top-right"
          autoClose={3000}
          pauseOnFocusLoss={false}
          newestOnTop
          hideProgressBar={true}
          transition={Flip}
        />
      </BrowserRouter>
    </PersistGate>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
